export default __webpack_public_path__ + "static/media/SittingRoom.8e2bbdf0.png";